import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import { useGetUserSlackIntegrations } from '../../services/slack.service';
import { useIntegrationsStore } from '../../store';

export const useGetSlackIntegrations = () => {
  const { getUserSlackIntegrations } = useGetUserSlackIntegrations();
  const { setUserSlackIntegrations } = useIntegrationsStore();

  const handleFetchSlackIntegrations = (forceRefresh = false) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.SLACK,
      forceRefresh,
      fetch: getUserSlackIntegrations,
      write: setUserSlackIntegrations,
    });

  return { handleFetchSlackIntegrations };
};
